export default __webpack_public_path__ + "static/media/database.d38a5c5f.svg";